import { parse } from "date-fns";

export const parseUrlAppHelper = {
  // Не из uikit: там `new Date(value)` — полночь UTC, и к западу от Гринвича фильтр съезжает на день.
  getDate: (searchParams: URLSearchParams, key: string): Date | undefined => {
    const value = searchParams.get(key);
    return value ? parse(value, "yyyy-MM-dd", new Date()) : undefined;
  },
  getEnumArray: <T extends string>(
    searchParams: URLSearchParams,
    key: string,
    enumType: Record<string, T>,
    defaultValues: T[] = []
  ): T[] =>
    searchParams
      .get(key)
      ?.split(",")
      .filter((val): val is T => val in enumType) ?? defaultValues,
};
